import React, { PropsWithChildren } from 'react';
import { gql } from '@yi/core';

import { baseClassesIndexName, getAnalyticIndexName } from '~/src/common/media-hero';
import { AboutTeacher } from '~/src/components/content-page-components';
import {
  DetailsContainer,
  Hero,
  Description,
  AnalyticsProvider,
} from '~/src/components/content-templates';
import { useAlgoliaProductViewedEvent } from '~/src/components/hooks';
import { useLocale } from '~/src/components/LocaleProvider';

import type { Content } from './types';

import { MetaInfo } from './MetaInfo';

interface Props {
  content: Content;
}

export const ClassPageContent: React.FC<PropsWithChildren<Props>> = ({ content }) => {
  const { locale } = useLocale();

  const { id } = content;
  const indexName = getAnalyticIndexName(baseClassesIndexName, locale);
  useAlgoliaProductViewedEvent({ contentID: id, indexName });

  return (
    <AnalyticsProvider trackingType={gql.typesClient.LogConsumptionTrackingType.CLASS}>
      <div>
        <DetailsContainer>
          <DetailsContainer.HeroBlock>
            <Hero content={content} />
          </DetailsContainer.HeroBlock>
          <DetailsContainer.MetaInfoBlock>
            <MetaInfo content={content} />
          </DetailsContainer.MetaInfoBlock>
          <DetailsContainer.DividerBlock />
          <DetailsContainer.DescriptionBlock>
            <Description content={content} />
          </DetailsContainer.DescriptionBlock>
        </DetailsContainer>
        <AboutTeacher content={content} />
      </div>
    </AnalyticsProvider>
  );
};
